module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ViewAgreementView.js"));
	}, "ViewAgreementView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ViewAgreementView!./src/pages/Shop/Home/Carnival/commonweal/ViewAgreement/ViewAgreementView.js
// module id = 954
// module chunks = 431